import React, { useRef } from 'react';
import styled from 'styled-components';
import { useTextField } from '@react-aria/textfield';

import { InputError } from '../../../InputError/InputError';
import { useForceFocus } from '../../../Hooks/useForceFocus';

type InputAriaProps = {
  id?: string,
  className?: string,
  label?: string,
  required?: boolean,
  requiredSymbol?: string,
  type?: string,
  as?: string,
  value?: string,
  onChange?: (value: string) => void,
  description?: string,
  error?: string,
  forceFocus?: boolean,
};

export const InputAria = (props : InputAriaProps) => {
  const ref = useRef<HTMLInputElement | HTMLTextAreaElement>();
  const { labelProps, inputProps, descriptionProps, errorMessageProps } = useTextField(props, ref);

  useForceFocus(ref, props.forceFocus);

  return (
    <InputAriaContainer className = {props.className}>
      <InputAriaLabel {...labelProps}>
        {props.label}
        {props.required
          && <InputAriaRequiredSymbol>{props.requiredSymbol || '*'}</InputAriaRequiredSymbol>
        }
      </InputAriaLabel>
      <InputAriaControlWrapper>
        {props.type === 'textarea'
          && <InputAriaControl
            {...inputProps as unknown as React.InputHTMLAttributes<HTMLTextAreaElement>}
            as = {'textarea'}
            value = {props.value}
            ref = {ref}
          />
        || <InputAriaControl
          {...inputProps as React.InputHTMLAttributes<HTMLInputElement>}
          type = {props.type}
          value = {props.value}
          ref = {ref}
        />
        }
      </InputAriaControlWrapper>
      {props.description && <InputAriaDescription {...descriptionProps}>{props.description}</InputAriaDescription> }
      {props.error && <InputAriaError {...errorMessageProps} error={props.error} /> }
    </InputAriaContainer>
  );
};

export const InputAriaContainer = styled.div``;
export const InputAriaControlWrapper = styled.div``;
export const InputAriaLabel = styled.label``;
export const InputAriaControl = styled.input``;
export const InputAriaRequiredSymbol = styled.span``;
export const InputAriaDescription = styled.div``;
export const InputAriaError = styled(InputError)``;


